import { FC, useContext } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const Tags: FC<any> = ({ data }) => {
	const { lang } = useContext(GlobalContext);

	return (
		<Wrapper>
			<TagsTitle>
				{translate(lang, { en: 'Tags', ru: 'Теги', ua: 'Теги' })}
			</TagsTitle>

			<TagsWrapper>
				{data?.map((tag, index) => (
					<LocalizedLink
						key={`blog_tag_${index}`}
						href={`/blog/tag/${tag.url}`}
					>
						<Tag>{tag?.tag}</Tag>
					</LocalizedLink>
				))}
			</TagsWrapper>
		</Wrapper>
	);
};

const Wrapper = styled.div`
	background-color: var(--color-white-30);
	border-radius: 16px;
	padding-top: 20px;
	padding-left: 20px;
	padding-right: 15px;
	padding-bottom: 20px;
	margin-top: 40px;
`;

const TagsTitle = styled.h4`
	font-family: var(--font-sans);
	font-weight: var(--font-bold);
	font-size: 14px;
	line-height: 15px;
	text-transform: uppercase;
	color: var(--color-black);
	margin-bottom: 17px;
`;

const TagsWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;

	a {
		cursor: pointer;
	}
`;

const Tag = styled.div`
	font-family: var(--font-sans);
	font-weight: var(--font-medium);
	font-size: 14px;
	line-height: 20px;
	color: var(--color-purple-50);
	background-color: var(--color-white);
	padding: 0 8px;
	margin-bottom: 8px;
	margin-right: 6px;
	border-radius: 14px;
	text-decoration: none;
	cursor: pointer;
`;

export default Tags;
